import React from 'react'
import { Job, JobWizardMobile } from 'sprockets_react/job_wizards/registries'
import $ from 'sprockets_react/job_wizards/jquery'

JobWizardMobile.GetContact = {
  onSubmit: function(onStepProgression, onRequest, onRequestCompletion, onStepRetreat) {
    let validatePhone = () => {
      let validationUrl = Job.Data.phoneVerificationRequired ? '/users/validate_mobile_contact_phone' : '/users/validate_contact_phone'

      $.ajax({
        url: validationUrl,
        dataType: 'json',
        data: { user_attributes: {
                  contact_phone: this.validator.getFieldElements('contact_phone').val()
                }
              }
      }).fail(function (error) {
        document.location = "/500"
      }).done((result) => {
        if (result.valid === true) {
          createUser()
        }
        else {
          this.validator.updateMessage('contact_phone', 'blank', result.error_message || 'Invalid Mobile Number')
          this.validator.updateStatus('contact_phone', 'INVALID', 'blank')
        }
      })
    }

    validatePhone()

    let createUser = () => {
      let subscribeToMessages = true

      var userObj = SS.API.V3.userCreate(
        {
          email: Job.Data.emailAddress,
          name: Job.Data.firstName,
          phone: Job.Data.phoneNumber,
          'autogenerate-password': true
        },
        {
          type: 'email-preferences',
          attrs: {
            'ss-update': subscribeToMessages,
            'sms-offers': subscribeToMessages
          }
        });

      $.ajax(userObj)
        .done((data) => {
          $('#user-session-id').attr('title', data.data.id)
          SS.currentUserId = data.data.id
          SS.userPhoneIsValid = data.meta.validPhone
          SS.userPhoneVerified = data.meta.verifiedPhone
          onStepProgression()
        })
        .fail((data) => {
          if (data.status === 422) {
            let res = data.responseJSON
            for (let i = 0; i < res.errors.length; i++) {
              this.errorMessage = this.errorMessage += ' ' + res.errors[i].detail
            }
          } else {
            this.errorMessage = 'Sorry we are unable to process your request at this time. Please try again later.'
            document.location.href = '/500'
          }
        })
    }
  },

  onLeftNavButtonClick(onStepProgression) {
    $('#job-modal').data('bootstrapValidator').removeField('contact_phone')
    JobWizardMobile.Emitter.emit('job:wizard:advanceToStep', JobWizardMobile.GetFirstName)
  },

  component: React.createClass({
    componentDidMount: function() {
      $('#job-modal').bootstrapValidator({ /* */ })
      JobWizardMobile.GetContact.validator = $('#job-modal').data('bootstrapValidator')
      this.setupValidation()
    },

    setupValidation: function () {
      JobWizardMobile.GetContact.validator.addField('contact_phone',
        { validators: {
            notEmpty: {
              message: 'Please enter your contact number'
            },
            blank: {}
          }
        }
      )
    },

    handlePhoneNumberChange: function(e) {
      Job.Actions.updatePhoneNumber(e.target.value)
    },

    render() {
      return (
        <div>
          <h3 className="mb15 mt20">What phone number can you be reached at?</h3>
          <div className="form-group">
            <div className="input-group p5 border radius-6 details-mobile">
              <input type="text" 
                     className="form-control"
                     onChange={this.handlePhoneNumberChange}
                     name="contact_phone" 
                     id="contact-phone"
                     defaultValue={Job.Data.phoneNumber}
              />
              <span className="input-group-btn">
                <JobWizardMobile.NavigationButtons
                  navButtonLayout='okButton'
                  onStepProgression={this.props.onStepProgression}
                /> 
              </span>
            </div>
          </div>
        </div>
      )
    }
  })
}
